import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-compose',
  templateUrl: './compose.component.html',
  styleUrls: ['./compose.component.css']
})
export class ComposeComponent implements OnInit {

  text: string;

  constructor(public dialogRef: MatDialogRef<ComposeComponent>) {
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(this.text);
  }
}
